export enum oSeriesPages {
  landing = '0-landing',
  startTest = '0-start-test',
  test1 = '1-test',
  test2 = '2-test',
  test3 = '3-test',
  test4 = '4-test',
  test5 = '5-test',
  test6 = '6-test',
  test7 = '7-test',
  test8 = '8-test',
  test8Edit = '8-test-edit',
  test9 = '9-test',
  test10 = '10-test',
  test11 = '11-test',
  test12 = '12-test',
  test13 = '13-test',
  test14 = '14-test',
  test15 = '15-test',
  test16 = '16-test',
  results17 = '17-results',
  checkout18 = '18-checkout',
  checkout19Retry = '19-checkout-retry',
  thankYou20 = '20-thank-you',
}
